import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Button } from '@components/ButtonV2';
import Icon from '@components/Icon';
import { Flex } from '@components/layout/Grid';
import { Modal, Body } from '@organisms/modals/base';
import { TaxonomyGroup as taxonomyGroup } from './TaxonomyTerms';
import ChevronUp from '@assets/ChevronUp';
import Accordion from '@components/Accordion';
import { SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';

const TaxonomyAccordionHead = styled(Flex)`
  padding: 13px 0;
  border-bottom: 1px solid rgb(216, 216, 216);

  svg {
    height: 7px;
    width: 24px;
    transform: rotateX(0deg);
    transition: transform 500ms ease-out;
    transform-origin: center center;
  }
`;

const TaxnomiesAccordion = styled(Accordion)`
  &.open ${TaxonomyAccordionHead} {
    color: rgb(18, 158, 220);
    font-weight: 600;

    svg {
      transform: rotateX(180deg);
    }
  }
`;

const TaxonomyAccordionBody = styled(Flex)`
  gap: 30px;
`;

const TaxonomyGroup = styled(taxonomyGroup)`
  & + & {
    padding-left: 0;
    border-left: none;
  }
`;

const ClearTags = styled.button`
  color: rgb(18, 158, 220);
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  border: none;
  border-radius: 12px;
  padding: 4px 8px;
  margin-right: 14px;
  background-color: rgb(219, 239, 248);
`;

const ModalHeader = styled(Flex)`
  background-color: rgba(241, 241, 241, 1);
`;

const TAXNOMIES_ORDER = [
  'durations',
  'needs',
  'yoga-workout',
  'health',
  'instructors',
  'bodyparts-needs',
  'accessories',
  'flavors',
  'skills',
];

export const FullTaxonomiesModal = ({
  clearAll,
  taxonomies,
  selectedTerms,
  handleSelectTerm,
  clearTaxonomy,
  onClose,
}) => {
  const [openedTaxonomy, setOpenedTaxonomy] = useState(null);

  const selectedTax = Object.values(selectedTerms).flat();
  return (
    <Modal open={true} handleClose={onClose}>
      <Body px={0} py={0}>
        <ModalHeader
          className="relative flex justify-between px-5 md:px-10"
          py={15}
        >
          <button className="text-base" onClick={clearAll}>
            <Trans id="videos_genres.reset_filters_btn" />
          </button>
          <div className="absolute left-1/2 -translate-x-1/2">
            <span className="flex items-center gap-2 font-semibold text-base">
              <SlidersHorizontal className="size-4" />
              <Trans id="videos_genres.filters_mobile_button" />{' '}
              {selectedTax?.length > 0 ? `(${selectedTax.length})` : null}
            </span>
          </div>
          <button className="" onClick={onClose}>
            <Icon name="ygb-icon-close" fontSize="12px" />
          </button>
        </ModalHeader>
        <div className="flex-1 flex flex-col justify-start px-5 md:px-11 pt-4 pb-6">
          {taxonomies.map((taxonomy) => {
            // const taxonomy = taxonomies.find(tax => tax.slug === slug);

            const _selectedTerms = selectedTerms[taxonomy.slug];

            return (
              <TaxnomiesAccordion
                // className="max-w-lg"
                key={taxonomy.slug}
                isOpen={openedTaxonomy === taxonomy.slug}
                onOpenChange={() => setOpenedTaxonomy(taxonomy.slug)}
                head={
                  <TaxonomyAccordionHead
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {taxonomy.name}
                    <div>
                      {_selectedTerms?.length > 0 ? (
                        <ClearTags
                          onClick={(e) => {
                            e.stopPropagation();
                            clearTaxonomy(taxonomy.slug);
                          }}
                        >
                          {_selectedTerms?.length}{' '}
                          <Icon name="ygb-icon-close" />
                        </ClearTags>
                      ) : null}
                      <ChevronUp />
                    </div>
                  </TaxonomyAccordionHead>
                }
                body={
                  <TaxonomyAccordionBody flexDirection="column" py={20}>
                    {taxonomy.subcategories?.length > 0 ? (
                      taxonomy.subcategories.map((subcategory) => {
                        return (
                          <TaxonomyGroup
                            key={subcategory.name}
                            title={
                              <Trans
                                id="videos_genres.taxonomy_subcategory.title"
                                values={{ title: subcategory.name }}
                              />
                            }
                            selectedTerms={_selectedTerms}
                            terms={subcategory.terms}
                            slug={taxonomy.slug}
                            onSelectTerm={handleSelectTerm}
                          />
                        );
                      })
                    ) : (
                      <TaxonomyGroup
                        title={null}
                        selectedTerms={_selectedTerms}
                        terms={taxonomy.nonSubcategorized}
                        slug={taxonomy.slug}
                        onSelectTerm={handleSelectTerm}
                      />
                    )}
                  </TaxonomyAccordionBody>
                }
              />
            );
          })}
        </div>
        <div className="sticky bottom-0 flex items-center justify-center border-t border-neutral-200 px-10 py-3 bg-white">
          <Button className="w-full justify-center md:w-auto" onClick={onClose}>
            <Trans id="videos_genres.taxonomies_modal.apply_filters_btn" />
          </Button>
        </div>
      </Body>
    </Modal>
  );
};
